import { Action } from 'redux';
import { asyncScheduler, concat, Observable, of, race, scheduled } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { map, mergeMap } from 'rxjs';

import { CartActions, CartMsg } from '../cart.actions';

export function refreshCartAndRetry<A extends Action = Action<any>, B extends Action = Action<any>>(
    actions$: Observable<any>,
    action: A,
    errorAction: B,
) {
    return concat(
        of(CartMsg('Cart.Fetch', undefined)),
        race(
            actions$.pipe(
                ofType<CartActions>('Cart.FetchSuccess'),
                map(() => action),
            ),
            actions$.pipe(
                ofType<CartActions>('Cart.FetchError'),
                mergeMap(() => scheduled(of(errorAction), asyncScheduler)),
            ),
        ),
    );
}
